import { Alert, Box, Button } from '@chakra-ui/react'
import ConfettiAnimation from 'commons/components/confetti/ConfettiAnimation'
import { TextColorsRaw } from 'commons/design-system/tokens'
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary'
import { useTranslation } from 'react-i18next'

export const ErrorBoundary = ({ children }: { children: React.ReactNode }) => {
	const { t } = useTranslation()
	const crossShape = (ctx: CanvasRenderingContext2D) => {
		const scale = 1.75 // Adjust this value to make bigger/smaller
		const size = 6 * scale
		const thickness = 2.5 * scale

		ctx.beginPath()
		// First diagonal \
		ctx.save()
		ctx.rotate(Math.PI / 4) // 45 degrees
		ctx.rect(-thickness / 2, -size, thickness, size * 2)
		ctx.restore()

		// Second diagonal /
		ctx.save()
		ctx.rotate(-Math.PI / 4) // -45 degrees
		ctx.rect(-thickness / 2, -size, thickness, size * 2)
		ctx.restore()

		ctx.fill()
	}

	return (
		<ReactErrorBoundary
			fallbackRender={({ error, resetErrorBoundary }) => {
				console.error('Fallback render in ErrorBoundary:', error)
				return (
					<Box
						h={'100vh'}
						w={'full'}
						display={'flex'}
						justifyContent={'center'}
						alignItems={'center'}
						p={4}
					>
						<ConfettiAnimation
							drawShape={crossShape}
							numberOfPieces={50}
							gravity={0.075}
							wind={-0.01}
							opacity={0.8}
							colors={[TextColorsRaw.STATUS_ERROR, TextColorsRaw.STATUS_ERROR_DARKER]}
						/>
						<Alert.Root status='error' maxW={'650px'}>
							<Alert.Indicator />
							<Alert.Content>
								<Alert.Title>{t('error_something_went_wrong')}</Alert.Title>
								<Alert.Description>{error.message}</Alert.Description>
								<Button mt={2} onClick={() => resetErrorBoundary()} variant='danger'>
									{t('error_try_again')}
								</Button>
							</Alert.Content>
						</Alert.Root>
					</Box>
				)
			}}
		>
			{children}
		</ReactErrorBoundary>
	)
}
